import { Guid } from "@/types"
import { AssetCategory, IGetAssetCategoryDto } from "./AssetCategory"

export interface IGetDepreciationPeriodDto {
    assetCategory: IGetAssetCategoryDto
    depreciationPeriodIfrsMachines: number
    depreciationPeriodIfrsEquipment: number
    depreciationPeriodLocalMachines: number
    depreciationPeriodLocalEquipment: number
}

export interface ICreateDepreciationPeriodDto {
    assetCategoryId: Guid
    depreciationPeriodIfrsMachines: number
    depreciationPeriodIfrsEquipment: number
    depreciationPeriodLocalMachines: number
    depreciationPeriodLocalEquipment: number
}

export default class DepreciationPeriod {
    assetCategory: AssetCategory
    depreciationPeriodIfrsMachines: number
    depreciationPeriodIfrsEquipment: number
    depreciationPeriodLocalMachines: number
    depreciationPeriodLocalEquipment: number

    constructor(dto: IGetDepreciationPeriodDto) {
        this.assetCategory = new AssetCategory(dto.assetCategory)
        this.depreciationPeriodIfrsMachines = dto.depreciationPeriodIfrsMachines
        this.depreciationPeriodIfrsEquipment = dto.depreciationPeriodIfrsEquipment
        this.depreciationPeriodLocalMachines = dto.depreciationPeriodLocalMachines
        this.depreciationPeriodLocalEquipment = dto.depreciationPeriodLocalEquipment
    }
}
